import { render, staticRenderFns } from "./LinkItem.vue?vue&type=template&id=0f3acb32&"
import script from "./LinkItem.vue?vue&type=script&lang=ts&"
export * from "./LinkItem.vue?vue&type=script&lang=ts&"
import style0 from "./LinkItem.vue?vue&type=style&index=0&id=0f3acb32&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports